<template>
  <div class="serviceAuth">
    <div class="form-item">
      <label class="label"><i class="required">*</i>团队规模：</label>
      <div class="input-box">
        <el-select v-model="form.teamPeopleCount" value-key="text" placeholder="团队规模">
          <el-option v-for="item in companySize" :key="item.value" :value="item.value" :label="item.text"></el-option>
        </el-select>
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>主营业务：</label>
      <div class="input-box">
        <textarea class="textarea" v-model.trim="form.companySummary" maxlength="500" placeholder="主营业务"></textarea>
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>纳税属性：</label>
      <div class="input-box line-h35">
        <el-checkbox-group v-model="form.enterPriseProperty">
          <el-checkbox :label="item.value" v-for="(item,index) in items" :key="index">{{item.text}}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>业务联系人：</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.linkMan" maxlength="50" type="text" placeholder="业务联系人">
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>联系电话：</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.handSet" type="text" placeholder="业务联系人联系电话">
      </div>
    </div>
    <div class="form-item">
      <label class="label">技术负责人：</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.technologyLinkMan" type="text" placeholder="技术负责人">
      </div>
    </div>
    <div class="form-item">
      <label class="label">联系电话：</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.technologyHandset" type="text" placeholder="技术负责人联系电话">
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>办公地址：</label>
      <div class="input-box">
        <input class="input readonly" readonly @click="openMap" type="text" :value="form.fullAddress" placeholder="选择地址">
        <i class="icon-local el-icon el-icon-location-outline"></i>
      </div>
      <div class="input-box">
        <input class="input" v-model.trim="form.address" type="text" placeholder="门牌号">
      </div>
    </div>
    <div class="form-item">
      <label class="label">公司负责人：</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.dutyLinkMan" type="text" placeholder="公司负责人">
      </div>
    </div>
    <div class="form-item">
      <label class="label">联系电话：</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.dutyHandSet" type="text" placeholder="公司负责人联系电话">
      </div>
    </div>
    <div class="form-item">
      <label class="label">母公司：</label>
      <div class="input-box">
        <input class="input readonly" readonly :value="pickedCompany.CompanyName" @click="showCompanyList=true" type="text" placeholder="母公司">
      </div>
    </div>
    <div class="form-item">
      <label class="label">年营业额：</label>
      <div class="input-box">
        <input class="input" v-model.number="form.yearlyTurnover" type="text" placeholder="年营业额">
        <span class="unit">万元</span>
      </div>
    </div>
    <div class="form-item">
      <span class="label"></span>
      <div class="input-box">
        <!-- <button class="btn-default" @click="prevStep" v-if="!isEdit">上一步</button> -->
        <button class="btn-primary" @click="save">下一步</button>
      </div>
    </div>
    <my-dialog class="map-dialog" :show="showMap" title="办公地址" @close="showMap=false;">
      <iframe id="map" :src="mapUrl" frameborder="0" class="baidu-map"></iframe>
    </my-dialog>
    <my-dialog class="company-list-dialog" :show="showCompanyList" title="关联母公司" @close="showCompanyList=false;">
      <div class="search-wrapper">
        <div class="search-box">
          <input type="text" v-model="companyName" autocomplete="false" placeholder="企业名称" @keydown.enter="loadCompanyList">
          <i class="icon-search">
            <svg class="icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1312"><path d="M954.572 922.815l-167.229-180.474c71.167-76.249 114.775-178.533 114.775-290.814 0-235.209-191.361-426.563-426.563-426.563-235.209 0-426.563 191.355-426.563 426.563s191.355 426.563 426.563 426.563c93.821 0 180.667-30.449 251.172-81.984l168.429 181.771c7.977 8.617 18.829 12.975 29.721 12.975 9.85 0 19.725-3.573 27.519-10.791 16.402-15.21 17.391-40.836 2.175-57.245zM130.004 451.526c0-190.537 155.015-345.551 345.551-345.551 190.543 0 345.551 155.015 345.551 345.551s-155.007 345.552-345.551 345.552c-190.537 0-345.551-155.015-345.551-345.552z" p-id="1313"></path></svg>
          </i>
        </div>
        <button class="btn-text" @click="loadCompanyList">搜索</button>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th width="20px"></th>
            <th>公司名称</th>
            <th>企业所在地</th>
            <th>联系人</th>
            <th>联系电话</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in companyList" :key="index">
            <td>
              <label class="radiobox">
                <input type="radio" name="company" v-model="pickedCompany"  :value="item" >
                <span class="icon-radio"></span>
              </label>
            </td>
            <td>{{item.CompanyName}}</td>
            <td>{{item.CityName}}</td>
            <td>{{item.LinkMan}}</td>
            <td>{{item.HandSet}}</td>
          </tr>
        </tbody>
      </table>
      <el-pagination
        layout="prev, pager, next,jumper"
        :current-page.sync="pageNum"
        @current-change="loadCompanyList"
        :total="total">
      </el-pagination>
      <div class="btn-primary" @click="confirmPick">确定</div>
    </my-dialog>
  </div>
</template>
<script>
import Dialog from "@/components/gkDialog.vue";
import { 
  GetCompanyList,
  AddErrorLog
} from '@/scripts/api.js'
import {mapState} from 'vuex'
import validate from '@/scripts/validate.js'
import Bus from '@/scripts/bus.js'
export default {
  components: {
    "my-dialog": Dialog,
  },
  data(){
    return{
      form:{
        teamPeopleCount:'',
        companySummary:'',
        enterPriseProperty:[],
        linkMan:'',
        handSet:'',
        technologyLinkMan:'',
        technologyHandset:'',
        address:'',
        provinceId:0,
        cityId:0,
        cityName:0,
        xianId:0,
        lng:0,
        lat:0,
        fullAddress:'',
        dutyLinkMan:'',
        dutyHandSet:'',
        parentCompanyId:0,
        yearlyTurnover:'',
      },
      items:[{value:1,text:'1%'},{value:3,text:'3%'},{value:6,text:'6%'},{value:9,text:'9%'},{value:13,text:'13%'}],
      companySize:[{value:1,text:'5人以下'},{value:2,text:'5-15人'},{value:3,text:'15人以上'}],
      showMap:false,
      showCompanyList:false,
      companyList:[],
      companyName:'',
      pageNum:1,
      total:0,
      pickedCompany:{},//选中的母公司
      companyData:{},
    }
  },
  props:{
    isEdit:{
      type:Boolean,
      default:false,
    }
  },
  computed: {
    ...mapState({
      userInfo:state=>state.userInfo,
      serviceInfo:state=>state.serviceInfo,
    }),
    //地图地址
    mapUrl(){
      let url=`${location.protocol}//${location.host}${location.pathname}#/baiduMap?userType=${this.userInfo?this.userInfo.LoginAccountType:0}&userId=${this.userInfo?this.userInfo.LoginAccountId:0}`;
      return url;
    }
  },
  watch: {
    serviceInfo(value){
      if(value){
        this.form={
          teamPeopleCount:value.TeamPeopleCount || '',
          companySummary:value.CompanySummary,
          enterPriseProperty: value.EnterPrisePropertyList.map(item=>{
            return item.EnterPrisePropertyId;
          }),
          linkMan:value.LinkMan,
          handSet:value.HandSet,
          technologyLinkMan:value.TechnologyLinkMan,
          technologyHandset:value.TechnologyHandset,
          address:value.Address,
          // provinceId:value.ProvinceID,
          // cityId:value.CityID,
          // xianId:value.XianID,
          cityName:value.CityName,
          lng:value.Lng,
          lat:value.Lat,
          fullAddress:value.FullAddress,
          dutyLinkMan:value.DutyLinkMan,
          dutyHandSet:value.DutyHandSet,
          parentCompanyId:value.ParentCompanyId,
          yearlyTurnover:value.YearlyTurnover,
        }
        this.pickedCompany={
          CompanyName:value.ParentCompanyName,
          CompanyId:value.ParentCompanyId,
        }
      }
    }
  },
  created() {
    this.receiveData();
    this.loadCompanyList();
    let that=this;
    Bus.$on('toRegService',(data)=>{
      that.companyData={
        ...data,
      }
    });
  },
  methods: {
    //上一步
    prevStep(){
      this.$emit('stepChange',1);
    },
    //接受iframe传出来的信息
    receiveData(){
      let that=this;
      window.addEventListener('message',function(e) {
        let data={};
        let value=e.data;
        if(that.$isJsonString(value)){
          data=JSON.parse(value);
        }
        if(data.Lat){
          that.form.fullAddress=data.FullAddress;
          that.form.cityName=data.CityName;
          that.form.lng=data.Lng;
          that.form.lat=data.Lat;
          that.showMap=false;
        }
      })
    },
    openMap(){
      this.showMap=true;
      let data={
        FullAddress:this.form.fullAddress,
        Lng:this.form.lng,
        Lat:this.form.lat,
        CityName:this.form.cityName,
      }
      this.$nextTick(()=>{
        if(data){
          document.getElementById('map').contentWindow.postMessage(JSON.stringify(data),'*');
        }
      })
    },
    //获取公司列表
    loadCompanyList(){
      GetCompanyList({
        companyName:this.companyName,
        platform:'pcweb',
        pageSize:10,
        pageNum:this.pageNum,
      }).then(r=>{
        if(r.Result==1){
          this.total=r.Data.TotalCount;
          this.companyList=r.Data.CompanyList || [];
        }
      })
    },
    //
    confirmPick(){
      this.form.parentCompanyId=this.pickedCompany.CompanyId;
      this.showCompanyList=false;
    },
    //下一步
    save(){
      if(this.form.teamPeopleCount==''){
        this.$toast('请选择团队规模');
        AddErrorLog('/ApplyServiceStation','请选择团队规模');
        return;
      }
      if(this.form.companySummary==''){
        this.$toast('请输入主营业务');
        AddErrorLog('/ApplyServiceStation','请输入主营业务');
        return;
      }
      if(!this.form.enterPriseProperty.length){
        this.$toast('请选择纳税属性');
        AddErrorLog('/ApplyServiceStation','请选择纳税属性');
        return;
      }
      if(this.form.linkMan ==''){
        this.$toast('请输入业务联系人');
        AddErrorLog('/ApplyServiceStation','请输入业务联系人');
        return;
      }
      if(this.form.handSet==''){
        this.$toast('请输入业务联系人电话');
        AddErrorLog('/ApplyServiceStation','请输入业务联系人电话');
        return;
      }
      if (
        this.form.handSet !== "" &&
        !validate.link(this.form.handSet)
      ) {
        this.$toast("业务联系人电话格式不正确");
        return;
      }
      if (
        this.form.technologyHandset !== "" &&
        !validate.link(this.form.technologyHandset)
      ) {
        this.$toast("技术负责人电话格式不正确");
        return;
      }
      if(this.form.fullAddress ==''){
        this.$toast('请选择办公地址');
        AddErrorLog('/ApplyServiceStation','请选择办公地址');
        return;
      }
      if(this.form.address==''){
        this.$toast('请输入详细地址');
        AddErrorLog('/ApplyServiceStation','请输入详细地址');
        return;
      }
      if(isNaN(Number(this.form.yearlyTurnover))){
        this.$toast('营业额请输入数字');
        AddErrorLog('/ApplyServiceStation','营业额请输入数字');
        return;
      }
      if(this.form.yearlyTurnover<0){
        this.$toast('营业额不能小于0');
        AddErrorLog('/ApplyServiceStation','营业额不能小于0');
        return;
      }
      this.$emit('stepChange',3);
      Bus.$emit('toServiceAuth2',{
        ...this.form,
        ...this.companyData,
      });
    },
  },
}
</script>
<style lang="scss">
.serviceAuth{
  .input.readonly:read-only{
    background-color: #fff;
    cursor: pointer;
  }
  .baidu-map{
    width: 100%;
    height: 500px;
  }
  .radiobox{
        position: relative;
        cursor: pointer;
        line-height: 36px;
        margin-right: 30px;
        input{
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            z-index: 2;
        }
    }
    .icon-radio{
        display: inline-block;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 1px solid #666;
        background-color: #fff;
        margin-right: 10px;
        vertical-align: middle;
    }
    :checked+.icon-radio{
        border-color: #f75959;
        background-color: #f75959;
        padding: 2px;
        background-clip: content-box;
    }
    .radio-text{
        vertical-align: middle;
        white-space: nowrap;
        font-size: 14px;
        color: #333;
    }
    .tips{
      font-size: 14px;
      color: #999;
      line-height: 38px;
    }
  .input-box+.input-box{
    margin-left: 120px;
    margin-top: 20px;
  }
  .input-box.line-h35 {
    height: 35px;
    line-height: 35px;
  }
  .unit{
    position: absolute;
    right: 10px;
    top: 0;
    z-index: 2;
    line-height: 38px;
    font-size: 14px;
    color: #999;
  }
  .icon-local{
    position: absolute;
    right: 10px;
    top: 0;
    z-index: 2;
    line-height: 38px;
    font-size: 20px;
    color: #999;
  }
  .el-select{
    width: 100%;
    *{
      height: 38px;
      line-height: 38px;
    }
    .el-input__inner{
      &:read-only{
        cursor:auto;
        background-color: #fff;
      }
    }
  }
}
.company-list-dialog{
  .search-wrapper{
    overflow: hidden;
    margin-bottom: 10px;
  }
  .search-box{
    float: left;
    position: relative;
    input{
      width: 280px;
      border: 1px solid #e5e5e5;
      background: #fff;
      padding-left: 35px;
      border-radius: 30px;
      line-height: 30px;
      height: 30px;
      font-size: 14px;
      font-family: "DIN-Regular";
      color: #666;
    }
    .icon-search{
      position: absolute;
      left: 10px;
      top: 4px;
      line-height: 1;
      font-size:18px;
      color: #f75959;
    }
  }
  .btn-text{
    float: left;
    font-size: 14px;
    color: #f75959;
    line-height: 30px;
    background-color: transparent;
    margin-left: 10px;
    cursor: pointer;
  }
  .table{
    width: 100%;
    border-collapse: collapse;
    text-align-last: left;
    th{
      font-size: 14px;
      color: #666;
      line-height: 40px;
      font-weight: normal;
      border-bottom: 1px solid #f75959;
    }
    td{
      font-size: 14px;
      color: #666;
      line-height: 40px;
      border-bottom: 1px solid #e5e5e5;
    }
    tbody{
      height: 300px;
      max-height: 300px;
      overflow-y: auto;
    }
    .radiobox{
      margin-right: 0;
    }
  }
  .el-pagination{
    text-align: right;
    margin-top:10px;
  }
  .btn-primary{
    display: block !important;
    margin: 20px auto 0;
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
}
</style>